<template>
  <div class="content">
    <h1 ref="title">Question {{ quiz }}</h1>
    <p ref="text" v-html="question"></p>
    <div class="button-wrapper">
      <hi-button-answer
        v-for="(answer, key) in answers"
        :key="answer.id"
        :data-index="key"
        :correct_answer="answer.correct_answer"
        :delay="key"
      >
        <span v-html="answer.title"></span>
      </hi-button-answer>
    </div>
  </div>
</template>

<script>
// import Anime from "animejs/lib/anime.es.js";

export default {
  props: ["answers", "correct_answer", "quiz", "question"],
  methods: {
    runAnimation() {
      // let btns = Array.from(document.querySelectorAll(".my-anim"));
      // Anime(
      //   {
      //     targets: btns,
      //     translateY: [-60, 0],
      //     opacity: [0, 1],
      //     duration: 1000,
      //     delay: Anime.stagger(200),
      //   },
      //   "-=1000"
      // );
    },
  },
  mounted() {
    this.runAnimation();
  },
};
</script>
